import React from 'react'
import img1 from '../Components/Images/CIJ/cij.png'
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import './cij1.css'
import './zartecbutton.css'

function Cijtest({onScrollToExplanation}) {
  return (
    <div>
      <section className="merchandise-display-section ">
  <div className="tech-dots dots-1"></div>
  <div className="tech-dots dots-2"></div>
  <Container>
    <Row className="align-items-center">
      <Col lg={6} className="mb-5 mb-lg-0">
        <div className="display-content">
          <span className="product-category d-inline-block">Advanced Technology</span>
          <h2 className="section-title" style={{fontFamily: "Poppins"}}>CONTINUOUS INKJET PRINTERS</h2>
          <p className="description" style={{fontFamily: "Montserrat"}}>
            Experience industrial precision with our next-generation Continuous Inkjet Printers. 
            Engineered for 24/7 operation, these systems deliver exceptional print clarity on virtually 
            any surface while minimizing maintenance and downtime. Perfect for batch coding, expiry dates, 
            and serialization in demanding environments where reliability is non-negotiable.
          </p>
          <div className="d-flex align-items-center mt-4">
            <Link to="/contact-us" className="text-decoration-none">
              <Button size="lg" className="cta-button">
                Request a Quote
              </Button>
            </Link>
            <Link to="#" onClick={onScrollToExplanation}  className="text-decoration-none ms-4">
              <div className="d-flex align-items-center">
                <span style={{color: "#3498db", fontWeight: "600"}}>Explore Features</span>
                <i className="bi bi-arrow-right ms-2" style={{color: "#3498db"}}></i>
              </div>
            </Link>
          </div>
        </div>
      </Col>
      <Col lg={5}>
        <div className="display-image">
          <img
            src={img1}
            alt="Industrial continuous inkjet printer"
            className="img-fluid floating-image"
          />
          <div className="text-center mt-3">
            <span className="badge bg-light text-dark p-2" style={{fontFamily: "Montserrat", fontWeight: "500"}}>
              <i className="bi bi-check-circle-fill me-2" style={{color: "#3498db"}}></i>Industry-leading 99.9% uptime
            </span>
          </div>
        </div>
      </Col>
    </Row>
  </Container>
</section>
    </div>
  )
}

export default Cijtest
